import { useLayoutEffect, useState } from "react";
function useContainerBreakpoint(ref, thresholdPx) {
    const [isAtOrAboveThreshold, setIsAtOrAboveThreshold] = useState(false);
    useLayoutEffect(()=>{
        const element = ref.current;
        if (!element) return;
        setIsAtOrAboveThreshold(element.getBoundingClientRect().width >= thresholdPx);
        const observer = new ResizeObserver(([entry])=>{
            if (entry) setIsAtOrAboveThreshold(entry.contentRect.width >= thresholdPx);
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        ref,
        thresholdPx
    ]);
    return isAtOrAboveThreshold;
}
export { useContainerBreakpoint };
